import { handleActions } from 'redux-actions'

import {
  SET_MODAL,
  CLEAR_MODAL
} from '../actions/modal'

import update from 'immutability-helper'

export default handleActions({
  [SET_MODAL]: (state, action) => {
    return update(state, {
      $set: {
        name: action.payload.name,
        data: action.payload.data
      }
    })
  },
  [CLEAR_MODAL]: (state, action) => {
    return update(state, {
      $set: {}
    })
  }
}, {})



// WEBPACK FOOTER //
// ./src/reducers/modal.js